import React, { useState, useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';
import HondaLoader from '../components/common/HondaLoader';
import { sanitizeInput } from '../utils/inputValidation';
import { getUserListing, getUserInfo, editUserData, editUserStatus, editUserResetPasswordFlag, addUser } from '../services/userservice';
const ABMUsuarios = ({ user, onLogout, onNavigate }) => {
    const [busqueda, setBusqueda] = useState('');
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [mostrarAgregarModal, setMostrarAgregarModal] = useState(false);
    const [usuarioEditando, setUsuarioEditando] = useState(null);
    const [modalReset, setModalReset] = useState(false);
    const [modalBloquear, setModalBloquear] = useState(false);
    const [resetLink, setResetLink] = useState('');
    const [mostrarLink, setMostrarLink] = useState(false);
    const [sufijoUsername, setSufijoUsername] = useState('_000001');
    const [tipoUsuarioNuevo, setTipoUsuarioNuevo] = useState('1');
    const [modalNuevoUsuarioLink, setModalNuevoUsuarioLink] = useState(false);
    const [nuevoUsuarioData, setNuevoUsuarioData] = useState(null);
    // Estados para manejo de operaciones
    const [loadingUserInfo, setLoadingUserInfo] = useState(false);
    const [savingUserData, setSavingUserData] = useState(false);
    const [changingUserStatus, setChangingUserStatus] = useState(false);
    const [addingUser, setAddingUser] = useState(false);
    const [operationError, setOperationError] = useState(null);
    const [operationSuccess, setOperationSuccess] = useState(null);
    // Estado para alertas globales
    const [alertaGlobal, setAlertaGlobal] = useState(null);
    // Mapeo de ceID a nombre de concesionario
    const ceIDMap = {
        0: 'HONDA',
        1: 'HONDA',
        2: '06101',
        3: '02515',
        4: '03099',
        5: '03020',
        6: '03093',
        7: '03071',
        8: '03032',
        9: '01817',
        10: '03035',
        11: '04512',
        12: '05234',
        13: '07891',
        14: '08342',
        15: '09123',
        16: '06789'
    };

    // Función para obtener el ceID real desde los usuarios existentes
    /*
    const getCEIDFromCodigo = (codigoCE) => {


        // Buscar un usuario existente que tenga este código de concesionario
        console.log("Aqui");
        console.log(codigoCE);
        console.log(usuarios);
        const usuarioConCE = usuarios.find(u => u.ce === codigoCE);
        console.log(usuarioConCE);
        if (usuarioConCE) {
            return usuarioConCE.ceID;
        }
        // Si no se encuentra, retornar null para manejarlo en el handler
        console.warn(`✗ No se encontró ningún usuario con CE ${codigoCE}`);
        return null;
    };
    */
    // Fetch usuarios desde la API
    useEffect(() => {
        fetchUsuarios();
    }, []);
    // Función para mapear los datos de la API al formato de la UI
    const mapApiUserToUIUser = (apiUser) => {
        // Mapear userStatus: 0 = INACTIVO, 1 = ACTIVO, 2 = BLOQUEADO
        const isBloqueado = apiUser.userStatus === 2;
        const estado = apiUser.userStatus === 0 ? 'INACTIVO' : apiUser.userStatus === 1 ? 'ACTIVO' : 'BLOQUEADO';
        // Transformar el array de modules a un objeto con propiedades booleanas
        const modulesArray = apiUser.modules || [];
        // Función auxiliar para verificar si un módulo está en el array
        const hasModule = (moduleId, moduleName) => {
            return modulesArray.some(mod => {
                // Si mod es un objeto
                if (typeof mod === 'object' && mod !== null) {
                    return mod.moduleID === moduleId || 
                           mod.id === moduleId || 
                           mod.name?.toLowerCase() === moduleName.toLowerCase();
                }
                // Si mod es un número
                if (typeof mod === 'number') {
                    return mod === moduleId;
                }
                // Si mod es un string
                if (typeof mod === 'string') {
                    return mod.toLowerCase() === moduleName.toLowerCase();
                }
                return false;
            });
        };
        const modulos = {
            cesiones: hasModule(1, 'cesiones'),
            prendas: hasModule(2, 'prendas'),
            scoring: hasModule(3, 'scoring')
        };
        return {
            id: apiUser.id,
            nombre: apiUser.name || '',
            apellido: apiUser.lastName || '',
            username: apiUser.username || '',
            email: apiUser.email || '',
            ce: ceIDMap[apiUser.ceID] || apiUser.ceID?.toString() || 'N/A',
            ceFullName:  apiUser.ceFullName,
            ceID: apiUser.ceID,
            estado: estado,
            bloqueado: isBloqueado,
            groupID: apiUser.groupID,
            passwordResetFlag: apiUser.passwordResetFlag,
            modules: apiUser.modules || [],
            modulos: modulos,
            userStatus: apiUser.userStatus
        };
    };
    // Función para cargar listado de usuarios
    const fetchUsuarios = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await getUserListing();
            // DEBUG: Ver qué ceID y groupID usan los usuarios existentes
            const ceIDs = [...new Set(data.map(u => u.ceID))];
            const groupIDs = [...new Set(data.map(u => u.groupID))];
            const mappedUsers = data.map(mapApiUserToUIUser);
            setUsuarios(mappedUsers);
        } catch (err) {
            console.error('Error al cargar usuarios:', err);
            setError('Error al cargar los usuarios. Por favor, intente nuevamente.');
        } finally {
            setLoading(false);
        }
    };
    const concesionarias = [
        "000001 - CE PRUEBAS",
        "000020 - ASPEN",
        "000046 - BONDIO",
        "000065 - CABRAL MOTORS",
        "000081 - CETROGAR",
        "000097 - CORRIENTES",
        "000101 - CYCLOS",
        "000117 - MOTOS RATTIGAN",
        "000155 - GENAMAX",
        "000185 - LAS MALVINAS",
        "000192 - JUANJO MOTOS",
        "000227 - MASERA AUTOMOTORES",
        "000246 - MOTOR DOS",
        "000270 - NOURA S.A.",
        "000287 - PAPERINO",
        "000299 - PRODUCTOS",
        "000300 - PUEYRREDON MOTOS",
        "000311 - MG AUTOMOTORES",
        "000315 - HONDA PARANÁ",
        "000341 - TAMBURRINO HNOS",
        "000367 - YUHMAK",
        "000404 - RESONANCIAS",
        "000452 - MODICA MOTOS",
        "000456 - KAIZEN",
        "000458 - CORDOBA MOTOS",
        "000466 - DISTRIBUIDORA OESTE",
        "000496 - PARIS MOTOS",
        "000533 - DE TITTA JORGE ANTONIO",
        "000538 - ARRATE",
        "000048 - BORGMANN JOSE",
        "000074 - FUSSETTI",
        "000005 - AVANT MOTOS HONDA OFICIAL",
        "000253 - HONDA MOTOSUR",
        "000242 - MOTO ROMA",
        "000396 - MOTOLANDIA",
        "000284 - PALAZZI ROBERTO OSCAR",
        "000289 - PERFOMANCE BIKES",
        "000471 - POWER BIKES",
        "008146 - SIETE DEL UNO",
        "008149 - SIETE DEL UNO",
        "008158 - ASPEN",
        "008159 - YUHMAK",
        "008164 - CABRAL MOTORS",
        "008172 - PARIS MOTOS",
        "008174 - GENAMAX",
        "008175 - PARIS MOTOS",
        "008181 - YUHMAK",
        "008191 - CORRIENTES MOTOS",
        "008215 - GRUPO JDT",
        "008226 - SIETE DEL UNO",
        "008239 - PARIS MOTOS"
    ];



    const handleConcesionarioChange = (e) => {
        const selectedValue = e.target.value;
        const codigo = selectedValue.split(' - ')[0];
        setSufijoUsername(`_${codigo}`);
    };
    const usuariosFiltrados = usuarios.filter(usuario =>
        usuario.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
        usuario.apellido.toLowerCase().includes(busqueda.toLowerCase()) ||
        usuario.username.toLowerCase().includes(busqueda.toLowerCase()) ||
        usuario.email.toLowerCase().includes(busqueda.toLowerCase()) ||
        usuario.ce.toLowerCase().includes(busqueda.toLowerCase()) ||
        usuario.ceFullName.toLowerCase().includes(busqueda.toLowerCase())
    );
    const handleEditar = async (usuario) => {
        try {
            setLoadingUserInfo(true);
            setOperationError(null);
            setOperationSuccess(null);
            // Cargar información completa del usuario desde la API
            const userInfo = await getUserInfo(usuario.username);
            // Mapear la información del usuario al formato de la UI
            const usuarioCompleto = mapApiUserToUIUser(userInfo);
            setUsuarioEditando(usuarioCompleto);
            setMostrarModal(true);
        } catch (err) {
            console.error('Error al cargar información del usuario:', err);
            setOperationError('Error al cargar la información del usuario. Por favor, intente nuevamente.');
            alert('Error al cargar la información del usuario');
        } finally {
            setLoadingUserInfo(false);
        }
    };
    const handleGuardarEdicion = async (formData) => {
        try {
            setSavingUserData(true);
            setOperationError(null);
            setOperationSuccess(null);
            // Construir array de módulos seleccionados
            const modules = [];
            if (formData.get('cesiones') === 'on') modules.push(1);
            if (formData.get('prendas') === 'on') modules.push(2);
            if (formData.get('scoring') === 'on') modules.push(3);
            // Preparar datos para el endpoint EditUserData
            const userData = {
                id: usuarioEditando.id,
                name: formData.get('nombre'),
                lastName: formData.get('apellido'),
                username: usuarioEditando.username, // Mantener el username original
                email: formData.get('email'),
                groupID: usuarioEditando.groupID || 0,
                ceID: usuarioEditando.ceID || 0,
                modules: modules
            };
            // Llamar al endpoint EditUserData
            await editUserData(userData);
            // Verificar si cambió el estado (ACTIVO/INACTIVO)
            const nuevoEstado = formData.get('estado');
            let nuevoStatusNumerico;
            if (nuevoEstado === 'ACTIVO') {
                nuevoStatusNumerico = 1;
            } else if (nuevoEstado === 'INACTIVO') {
                nuevoStatusNumerico = 0;
            }
            // Solo cambiar el estado si es diferente al actual
            if (nuevoStatusNumerico !== undefined && nuevoStatusNumerico !== usuarioEditando.userStatus) {
                await editUserStatus(usuarioEditando.username, nuevoStatusNumerico);
            }
            // Refrescar la información del usuario
            const userInfo = await getUserInfo(usuarioEditando.username);
            const usuarioActualizado = mapApiUserToUIUser(userInfo);
            // Actualizar la lista de usuarios
            setUsuarios(usuarios.map(u => 
                u.username === usuarioActualizado.username ? usuarioActualizado : u
            ));
            // Cerrar modal inmediatamente
            setMostrarModal(false);
            setOperationSuccess(null);
            // Mostrar alerta de éxito
            setAlertaGlobal({
                tipo: 'success',
                mensaje: 'Usuario actualizado correctamente'
            });
            setTimeout(() => {
                setAlertaGlobal(null);
            }, 3000);
        } catch (err) {
            console.error('Error al guardar usuario:', err);
            setMostrarModal(false);
            setAlertaGlobal({
                tipo: 'error',
                mensaje: 'Error al guardar los datos del usuario. Por favor, intente nuevamente.'
            });
            setTimeout(() => {
                setAlertaGlobal(null);
            }, 3000);
        } finally {
            setSavingUserData(false);
        }
    };
    const handleReset = (usuario) => {
        setUsuarioEditando(usuario);
        setMostrarLink(false);
        setResetLink('');
        setModalReset(true);
    };
    const handleBloquear = (usuario) => {
        setUsuarioEditando(usuario);
        setOperationError(null);
        setOperationSuccess(null);
        setModalBloquear(true);
    };
    const handleCambiarEstadoUsuario = async () => {
        try {
            setChangingUserStatus(true);
            setOperationError(null);
            setOperationSuccess(null);
            // Determinar el nuevo estado
            // Si está bloqueado (2), desbloquear a activo (1)
            // Si está activo (1), bloquear (2)
            // Si está inactivo (0), activar (1)
            let newStatus;
            if (usuarioEditando.bloqueado || usuarioEditando.userStatus === 2) {
                newStatus = 1; // Desbloquear a ACTIVO
            } else {
                newStatus = 2; // Bloquear
            }
            // Llamar al endpoint EditUserStatus
            await editUserStatus(usuarioEditando.username, newStatus);
            // Refrescar la información del usuario
            const userInfo = await getUserInfo(usuarioEditando.username);
            const usuarioActualizado = mapApiUserToUIUser(userInfo);
            // Actualizar la lista de usuarios
            setUsuarios(usuarios.map(u => 
                u.username === usuarioActualizado.username ? usuarioActualizado : u
            ));
            // Cerrar modal inmediatamente
            setModalBloquear(false);
            setOperationSuccess(null);
            // Mostrar alerta de éxito
            setAlertaGlobal({
                tipo: 'success',
                mensaje: newStatus === 2 ? 'Usuario bloqueado correctamente' : 'Usuario desbloqueado correctamente'
            });
            setTimeout(() => {
                setAlertaGlobal(null);
            }, 3000);
        } catch (err) {
            console.error('Error al cambiar estado del usuario:', err);
            setModalBloquear(false);
            setAlertaGlobal({
                tipo: 'error',
                mensaje: 'Error al cambiar el estado del usuario. Por favor, intente nuevamente.'
            });
            setTimeout(() => {
                setAlertaGlobal(null);
            }, 3000);
        } finally {
            setChangingUserStatus(false);
        }
    };
    // Resetear contraseña - Genera link y activa flag de cambio obligatorio
    const handleResetearUsuario = async () => {
        try {
            // Activar flag de cambio obligatorio de contraseña
            await editUserResetPasswordFlag(usuarioEditando.username, 1);
            // Generar link de reseteo con username en el token
            const token = `${usuarioEditando.username}_${Date.now()}_${Math.random().toString(36).substring(7)}`;
            const resetLink = `${window.location.origin}/reset-password?token=${token}`;
            setResetLink(resetLink);
            setMostrarLink(true);
        } catch (error) {
            console.error('Error al activar flag de reseteo:', error);
            alert('Error al activar el reseteo de contraseña. El link se generó, pero el usuario no será forzado a cambiar su contraseña al iniciar sesión.');
            // Aún así generar el link
            const token = `${usuarioEditando.username}_${Date.now()}_${Math.random().toString(36).substring(7)}`;
            const resetLink = `${window.location.origin}/reset-password?token=${token}`;
            setResetLink(resetLink);
            setMostrarLink(true);
        }
    };
    const handleAgregarUsuario = async (nuevoUsuario) => {
        try {
            setAddingUser(true);
            setOperationError(null);
            setOperationSuccess(null);
            // Honda no utiliza concesionario ni sufijo en el username.
            const codigoCE = nuevoUsuario.concesionario?.split(' - ')[0];
            const ceID = nuevoUsuario.groupID === '2'
                ? 0
                : codigoCE;
            if (ceID === null) {
                throw new Error(`No se pudo determinar el ceID para el concesionario ${codigoCE}. Debe existir al menos un usuario de este concesionario.`);
            }
            // Usar el groupID seleccionado por el usuario
            const groupID = parseInt(nuevoUsuario.groupID);
            // Construir array de módulos con formato {id, name}
            const modules = [];
            if (nuevoUsuario.modulos.cesiones) {
                modules.push({ id: 1, name: 'Cesiones' });
            }
            if (nuevoUsuario.modulos.prendas) {
                modules.push({ id: 2, name: 'Prendas' });
            }
            if (nuevoUsuario.modulos.scoring) {
                modules.push({ id: 3, name: 'Scoring' });
            }
            // Preparar datos para el endpoint AddUser
            const userData = {
                name: nuevoUsuario.nombre,
                lastName: nuevoUsuario.apellido,
                username: nuevoUsuario.usernameCompleto,
                email: nuevoUsuario.email,
                groupID: groupID,
                ceID: ceID,
                modules: modules
            };
            // Llamar al endpoint AddUser
            await addUser(userData);
            // Esperar un momento para que el usuario se propague en la BD
            await new Promise(resolve => setTimeout(resolve, 500));
            // Activar flag de cambio obligatorio de contraseña para el nuevo usuario
            let resetFlagActivated = false;
            let lastError = null;
            // Intentar activar el flag con reintentos
            for (let i = 0; i < 3; i++) {
                try {
                    await editUserResetPasswordFlag(nuevoUsuario.usernameCompleto, 1);
                    resetFlagActivated = true;
                    break;
                } catch (error) {
                    console.warn(`⚠️ Error activando flag (intento ${i + 1}):`, error);
                    lastError = error;
                    if (i < 2) {
                        // Esperar antes del siguiente intento
                        await new Promise(resolve => setTimeout(resolve, 500));
                    }
                }
            }
            if (!resetFlagActivated) {
                console.error('❌ No se pudo activar el flag de reseteo después de 3 intentos');
                throw new Error(`Usuario creado pero no se pudo activar el cambio de contraseña obligatorio. Error: ${lastError?.message || 'Desconocido'}`);
            }
            // Verificar que el flag se activó correctamente
            const userInfo = await getUserInfo(nuevoUsuario.usernameCompleto);
            const resetFlag = userInfo.passwordResetFlag ?? userInfo.resetFlagPassword ?? 0;
            if (resetFlag !== 1) {
                console.error('❌ Verificación falló: resetFlag =', resetFlag);
                throw new Error('Usuario creado pero el flag de reseteo no está activo. Por favor, active manualmente el cambio de contraseña.');
            }
            // Generar link de reseteo con username en el token
            const token = `${nuevoUsuario.usernameCompleto}_${Date.now()}_${Math.random().toString(36).substring(7)}`;
            const resetLink = `${window.location.origin}/reset-password?token=${token}`;
            // Guardar datos para mostrar en el modal
            setNuevoUsuarioData({
                username: nuevoUsuario.usernameCompleto,
                nombre: nuevoUsuario.nombre,
                apellido: nuevoUsuario.apellido,
                email: nuevoUsuario.email
            });
            setResetLink(resetLink);
            // Cerrar modal de agregar
            setMostrarAgregarModal(false);
            // Refrescar la lista de usuarios
            await fetchUsuarios();
            // Mostrar modal con el link de reseteo
            setModalNuevoUsuarioLink(true);
        } catch (err) {
            console.error('Error al agregar usuario:', err);
            setMostrarAgregarModal(false);
            // Extraer mensaje de error más específico
            let errorMessage = 'Error al agregar el usuario. Por favor, intente nuevamente.';
            if (err.message.includes('No se pudo determinar el ceID')) {
                errorMessage = err.message;
            } else if (err.message.includes('FK_Usuarios_Grupos')) {
                errorMessage = 'Error: El grupo seleccionado no es válido. Contacte al administrador del sistema.';
            } else if (err.message.includes('FK_CE')) {
                errorMessage = 'Error: El concesionario seleccionado no es válido en el sistema.';
            } else if (err.message.includes('FOREIGN KEY')) {
                errorMessage = 'Error de validación: Uno de los datos no es válido en el sistema.';
            }
            setAlertaGlobal({
                tipo: 'error',
                mensaje: errorMessage
            });
            setTimeout(() => {
                setAlertaGlobal(null);
            }, 5000);
        } finally {
            setAddingUser(false);
        }
    };
    const getEstadoColor = (estado, bloqueado) => {
        if (bloqueado) {
            return 'text-red-600 bg-red-50';
        }
        if (estado === 'INACTIVO') {
            return 'text-yellow-600 bg-yellow-50';
        }
        return estado === 'ACTIVO' ? 'text-green-600 bg-green-50' : 'text-gray-600 bg-gray-50';
    };
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        alert('Link copiado al portapapeles');
    };
    return (
        <MainLayout user={user} onLogout={onLogout} onNavigate={onNavigate}>
            {/* Alerta global de éxito/error */}
            {alertaGlobal && (
                <div className="fixed top-4 right-4 z-50 animate-fade-in">
                    <div className={`px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3 min-w-[320px] max-w-md ${
                        alertaGlobal.tipo === 'success' 
                            ? 'bg-gradient-to-r from-green-500 to-emerald-600' 
                            : 'bg-gradient-to-r from-red-500 to-red-600'
                    }`}>
                        <span className="material-icons text-white text-2xl">
                            {alertaGlobal.tipo === 'success' ? 'check_circle' : 'error'}
                        </span>
                        <p className="text-white font-semibold flex-1">{alertaGlobal.mensaje}</p>
                        <button 
                            onClick={() => setAlertaGlobal(null)}
                            className="text-white/80 hover:text-white transition-colors"
                        >
                            <span className="material-icons text-xl">close</span>
                        </button>
                    </div>
                </div>
            )}
            {/* Loading overlay cuando se carga información del usuario */}
            {loadingUserInfo && (
                <HondaLoader 
                    message="Cargando información del usuario..." 
                    variant="overlay"
                    size="medium"
                    subtitle="Obteniendo datos actualizados"
                />
            )}
            {/* Loading overlay cuando se está agregando un usuario */}
            {addingUser && (
                <HondaLoader 
                    message="Agregando usuario..." 
                    variant="overlay"
                    size="medium"
                    subtitle="Por favor espere"
                />
            )}
            <div className="max-w-full mx-auto px-3 py-4 animate-fade-in-up">
                {/* Título mejorado */}
                <div className="mb-8">
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-1.5 h-8 gradient-red rounded-full shadow-glow-red"></div>
                        <h2 className="text-2xl font-bold text-gradient">
                            Listado de Usuarios
                        </h2>
                    </div>
                    <p className="text-gray-500 text-sm ml-5">Administre los usuarios del sistema de forma centralizada</p>
                </div>
                {/* Loading State */}
                {loading && (
                    <HondaLoader 
                        message="Cargando usuarios..." 
                        variant="inline"
                        size="medium"
                        subtitle="Por favor espere"
                    />
                )}
                {/* Error State */}
                {error && !loading && (
                    <div className="glass border-2 border-red-200 rounded-2xl shadow-soft p-6 mb-6 bg-gradient-to-br from-red-50 to-orange-50 animate-fade-in">
                        <div className="flex items-start gap-4">
                            <span className="material-icons text-red-600 text-3xl">error</span>
                            <div className="flex-1">
                                <h3 className="text-red-900 font-bold text-lg mb-2">Error al cargar usuarios</h3>
                                <p className="text-red-700 text-sm mb-4">{error}</p>
                                <button
                                    onClick={() => window.location.reload()}
                                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl transition-all duration-300 text-sm font-semibold flex items-center gap-2"
                                >
                                    <span className="material-icons text-base">refresh</span>
                                    Reintentar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {/* Content - Only show when not loading and no error */}
                {!loading && !error && (
                    <>
                {/* Barra de búsqueda y acciones mejorada - Optimizada para 1366x768 */}
                <div className="glass border border-gray-200 rounded-xl xl:rounded-2xl shadow-soft p-3 xl:p-5 mb-4 xl:mb-6 hover:shadow-lg transition-shadow duration-300">
                    <div className="flex gap-3 xl:gap-4">
                        <div className="flex-1 relative group">
                            <span className="material-icons absolute left-3 xl:left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg xl:text-xl group-hover:text-honda-500 transition-colors">
                                search
                            </span>
                            <input
                                type="text"
                                placeholder="Buscar usuario por nombre, apellido, username, email o CE..."
                                value={busqueda}
                                onChange={(e) => {
                                    const sanitized = sanitizeInput(e.target.value);
                                    setBusqueda(sanitized);
                                }}
                                className="w-full pl-10 xl:pl-12 pr-3 xl:pr-4 py-2 xl:py-3 bg-white border-2 border-gray-200 rounded-xl text-gray-800 text-xs xl:text-sm focus:outline-none focus:border-honda-500 focus:ring-4 focus:ring-honda-100 transition-all duration-300"
                            />
                        </div>
                        <button
                            onClick={() => {
                                setSufijoUsername('_000001');
                                setTipoUsuarioNuevo('1');
                                setMostrarAgregarModal(true);
                            }}
                            className="px-4 xl:px-6 py-2 xl:py-3 gradient-red hover:shadow-glow-red text-white rounded-xl transition-all duration-300 text-xs xl:text-sm font-semibold shadow-soft flex items-center gap-1 xl:gap-2 hover:-translate-y-0.5 ripple-effect"
                        >
                            <span className="material-icons text-sm xl:text-base">add_circle</span>
                            Nuevo Usuario
                        </button>
                    </div>
                </div>
                {/* Tabla mejorada - Optimizada para 1366x768 */}
                <div className="glass border-2 border-gray-200 rounded-xl xl:rounded-2xl shadow-soft overflow-hidden hover:shadow-lg transition-shadow duration-300">
                    <div className="overflow-x-auto scrollbar-thin">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gradient-to-r from-red-600 to-red-700">
                                <tr>
                                    <th className="px-3 xl:px-6 py-2 xl:py-4 text-left text-[10px] xl:text-xs font-bold text-white uppercase tracking-wider">Nombre</th>
                                    <th className="px-3 xl:px-6 py-2 xl:py-4 text-left text-[10px] xl:text-xs font-bold text-white uppercase tracking-wider">Apellido</th>
                                    <th className="px-3 xl:px-6 py-2 xl:py-4 text-left text-[10px] xl:text-xs font-bold text-white uppercase tracking-wider">Username</th>
                                    <th className="px-3 xl:px-6 py-2 xl:py-4 text-left text-[10px] xl:text-xs font-bold text-white uppercase tracking-wider">Email</th>
                                    <th className="px-3 xl:px-6 py-2 xl:py-4 text-left text-[10px] xl:text-xs font-bold text-white uppercase tracking-wider">CE</th>
                                    <th className="px-3 xl:px-6 py-2 xl:py-4 text-left text-[10px] xl:text-xs font-bold text-white uppercase tracking-wider">Estado</th>
                                    <th className="px-3 xl:px-6 py-2 xl:py-4 text-center text-[10px] xl:text-xs font-bold text-white uppercase tracking-wider">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-100">
                                {usuariosFiltrados.map((usuario, index) => (
                                    <tr key={usuario.id} className="hover:bg-gradient-to-r hover:from-honda-50/30 hover:to-transparent transition-all duration-200 animate-fade-in" style={{ animationDelay: `${index * 0.03}s` }}>
                                        <td className="px-3 xl:px-6 py-2 xl:py-4 text-[11px] xl:text-sm text-gray-900">{usuario.nombre}</td>
                                        <td className="px-3 xl:px-6 py-2 xl:py-4 text-[11px] xl:text-sm text-gray-900">{usuario.apellido || '-'}</td>
                                        <td className="px-3 xl:px-6 py-2 xl:py-4 text-[11px] xl:text-sm text-gray-900">{usuario.username}</td>
                                        <td className="px-3 xl:px-6 py-2 xl:py-4 text-[11px] xl:text-sm text-gray-900">{usuario.email || '-'}</td>
                                        <td className="px-3 xl:px-6 py-2 xl:py-4 text-[11px] xl:text-sm text-gray-900">{usuario.ceFullName || '-'}</td>
                                        <td className="px-3 xl:px-6 py-2 xl:py-4 text-[11px] xl:text-sm">
                                            <span className={`inline-flex items-center gap-1 xl:gap-1.5 px-2 xl:px-3 py-1 xl:py-1.5 text-[10px] xl:text-xs font-bold rounded-full shadow-sm ${getEstadoColor(usuario.estado, usuario.bloqueado)}`}>
                                                <span className="w-1 xl:w-1.5 h-1 xl:h-1.5 rounded-full bg-current"></span>
                                                {usuario.bloqueado ? 'BLOQUEADO' : usuario.estado}
                                            </span>
                                        </td>
                                        <td className="px-3 xl:px-6 py-2 xl:py-4 text-center">
                                            <div className="flex items-center justify-center gap-1 xl:gap-2">
                                                <button
                                                    onClick={() => handleEditar(usuario)}
                                                    className="group relative w-7 h-7 xl:w-9 xl:h-9 rounded-lg xl:rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 transition-all duration-300 flex items-center justify-center shadow-sm hover:shadow-md hover:-translate-y-0.5"
                                                    title="Editar usuario"
                                                >
                                                    <span className="material-icons text-blue-600 text-base xl:text-lg group-hover:scale-110 transition-transform">edit</span>
                                                </button>
                                                <button
                                                    onClick={() => handleReset(usuario)}
                                                    className="group relative w-7 h-7 xl:w-9 xl:h-9 rounded-lg xl:rounded-xl bg-gradient-to-br from-amber-50 to-amber-100 hover:from-amber-100 hover:to-amber-200 transition-all duration-300 flex items-center justify-center shadow-sm hover:shadow-md hover:-translate-y-0.5"
                                                    title="Resetear"
                                                >
                                                    <span className="material-icons text-amber-600 text-base xl:text-lg group-hover:rotate-180 transition-transform duration-500">autorenew</span>
                                                </button>
                                                <button
                                                    onClick={() => handleBloquear(usuario)}
                                                    className={`group relative w-7 h-7 xl:w-9 xl:h-9 rounded-lg xl:rounded-xl transition-all duration-300 flex items-center justify-center shadow-sm hover:shadow-md hover:-translate-y-0.5 ${usuario.bloqueado
                                                            ? 'bg-gradient-to-br from-red-50 to-red-100 hover:from-red-100 hover:to-red-200'
                                                            : 'bg-gradient-to-br from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200'
                                                        }`}
                                                    title={usuario.bloqueado ? "Usuario bloqueado" : "Bloquear usuario"}
                                                >
                                                    <span className={`material-icons text-base xl:text-lg group-hover:scale-110 transition-transform ${usuario.bloqueado ? 'text-red-600' : 'text-gray-400'
                                                        }`}>block</span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="px-4 xl:px-6 py-3 xl:py-4 border-t border-gray-200 bg-gradient-to-r from-gray-50 to-white">
                        <div className="flex items-center gap-2 text-xs xl:text-sm text-gray-600">
                            <span className="material-icons text-honda-500 text-base xl:text-lg">info</span>
                            <span>Mostrando <span className="font-semibold text-honda-700">{usuariosFiltrados.length}</span> de <span className="font-semibold text-honda-700">{usuarios.length}</span> usuario(s)</span>
                        </div>
                    </div>
                </div>
                </>
                )}
            </div>
            {/* Modal Agregar Usuario - Mejorado */}
            {mostrarAgregarModal && (
                <div className="fixed inset-0 z-50 overflow-y-auto animate-fade-in">
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => !addingUser && setMostrarAgregarModal(false)}></div>
                    <div className="relative min-h-screen flex items-center justify-center p-4">
                        <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full animate-scale-in">
                            {/* Header del modal con gradiente */}
                            <div className="gradient-red px-6 py-4 rounded-t-2xl shadow-lg">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                            <span className="material-icons text-white text-xl">person_add</span>
                                        </div>
                                        <h2 className="text-white text-lg font-bold tracking-wide">AGREGAR USUARIO</h2>
                                    </div>
                                    <button 
                                        onClick={() => !addingUser && setMostrarAgregarModal(false)} 
                                        disabled={addingUser}
                                        className="text-white/80 hover:text-white hover:rotate-90 transition-all duration-300 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed">
                                        <span className="material-icons text-xl">close</span>
                                    </button>
                                </div>
                            </div>
                            {/* Formulario con estilos mejorados */}
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                const formData = new FormData(e.target);
                                const nuevoUsuario = {
                                    nombre: formData.get('nombre'),
                                    apellido: formData.get('apellido'),
                                    email: formData.get('email'),
                                    username: formData.get('username'),
                                    usernameSuffix: sufijoUsername,
                                    usernameCompleto: tipoUsuarioNuevo === '2'
                                        ? formData.get('username')
                                        : formData.get('username') + sufijoUsername,
                                    groupID: formData.get('groupID'),
                                    modulos: {
                                        cesiones: formData.get('cesiones') === 'on',
                                        prendas: formData.get('prendas') === 'on',
                                        scoring: formData.get('scoring') === 'on'
                                    },
                                    concesionario: formData.get('concesionario')
                                };
                                handleAgregarUsuario(nuevoUsuario);
                            }} className="p-6">
                                <div className="space-y-4">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-2">Nombre:</label>
                                            <input 
                                                type="text" 
                                                name="nombre" 
                                                defaultValue="" 
                                                disabled={addingUser}
                                                className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed" 
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-2">Apellido:</label>
                                            <input 
                                                type="text" 
                                                name="apellido" 
                                                defaultValue="" 
                                                disabled={addingUser}
                                                className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed" 
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-700 mb-2">Email:</label>
                                        <input 
                                            type="email" 
                                            name="email" 
                                            disabled={addingUser}
                                            className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed" 
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-700 mb-2">Username:</label>
                                        <div className="flex gap-2">
                                            <input 
                                                type="text" 
                                                name="username" 
                                                defaultValue="" 
                                                disabled={addingUser}
                                                className="flex-1 px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed" 
                                            />
                                            {tipoUsuarioNuevo === '1' && (
                                                <input 
                                                    type="text" 
                                                    value={sufijoUsername} 
                                                    readOnly 
                                                    className="w-24 px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 text-gray-700 font-semibold" 
                                                />
                                            )}
                                        </div>
                                        <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
                                            <span className="material-icons text-xs">info</span>
                                            El sufijo se actualiza automáticamente según el concesionario
                                        </p>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-700 mb-2">Grupo:</label>
                                        <div className="flex gap-4">
                                            <label className="flex items-center gap-2 cursor-pointer group">
                                                <input 
                                                    type="radio" 
                                                    name="groupID" 
                                                    value="1"
                                                    defaultChecked 
                                                    onChange={() => setTipoUsuarioNuevo('1')}
                                                    disabled={addingUser}
                                                    className="w-4 h-4 text-honda-600 focus:ring-honda-500 cursor-pointer disabled:cursor-not-allowed" 
                                                />
                                                <span className="text-sm text-gray-700 font-medium group-hover:text-honda-600 transition-colors">Concesionario</span>
                                            </label>
                                            <label className="flex items-center gap-2 cursor-pointer group">
                                                <input 
                                                    type="radio" 
                                                    name="groupID" 
                                                    value="2" 
                                                    onChange={() => setTipoUsuarioNuevo('2')}
                                                    disabled={addingUser}
                                                    className="w-4 h-4 text-honda-600 focus:ring-honda-500 cursor-pointer disabled:cursor-not-allowed" 
                                                />
                                                <span className="text-sm text-gray-700 font-medium group-hover:text-honda-600 transition-colors">Honda</span>
                                            </label>
                                        </div>
                                        <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
                                        </p>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-700 mb-2">Módulos:</label>
                                        <div className="flex gap-6 items-center">
                                            <label className="flex items-center gap-2 cursor-pointer group">
                                                <input 
                                                    type="checkbox" 
                                                    name="cesiones" 
                                                    defaultChecked 
                                                    disabled={addingUser}
                                                    className="w-4 h-4 text-honda-600 rounded focus:ring-honda-500 cursor-pointer disabled:cursor-not-allowed" 
                                                />
                                                <span className="text-sm text-gray-700 font-semibold group-hover:text-honda-600 transition-colors">CESIONES</span>
                                            </label>
                                            <label className="flex items-center gap-2 cursor-pointer group">
                                                <input 
                                                    type="checkbox" 
                                                    name="prendas" 
                                                    defaultChecked 
                                                    disabled={addingUser}
                                                    className="w-4 h-4 text-honda-600 rounded focus:ring-honda-500 cursor-pointer disabled:cursor-not-allowed" 
                                                />
                                                <span className="text-sm text-gray-700 font-semibold group-hover:text-honda-600 transition-colors">PRENDAS</span>
                                            </label>
                                            <label className="flex items-center gap-2 cursor-pointer group">
                                                <input 
                                                    type="checkbox" 
                                                    name="scoring" 
                                                    defaultChecked 
                                                    disabled={addingUser}
                                                    className="w-4 h-4 text-honda-600 rounded focus:ring-honda-500 cursor-pointer disabled:cursor-not-allowed" 
                                                />
                                                <span className="text-sm text-gray-700 font-semibold group-hover:text-honda-600 transition-colors">SCORING</span>
                                            </label>
                                        </div>
                                    </div>
                                    {tipoUsuarioNuevo === '1' && (
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-2">Concesionario:</label>
                                            <select 
                                                name="concesionario" 
                                                onChange={handleConcesionarioChange} 
                                                disabled={addingUser}
                                                className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 cursor-pointer disabled:bg-gray-100 disabled:cursor-not-allowed">
                                                {concesionarias.map((conce, index) => (
                                                    <option key={index} value={conce}>{conce}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>
                                <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-100">
                                    <button 
                                        type="button" 
                                        onClick={() => setMostrarAgregarModal(false)} 
                                        disabled={addingUser}
                                        className="px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition-all duration-300 text-sm font-semibold hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
                                        Cancelar
                                    </button>
                                    <button 
                                        type="submit" 
                                        disabled={addingUser}
                                        className="px-5 py-2.5 gradient-red hover:shadow-glow-red text-white rounded-xl transition-all duration-300 text-sm font-semibold ripple-effect flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                                        {addingUser ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                Agregando...
                                            </>
                                        ) : (
                                            'Agregar'
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal Editar Usuario - Mejorado */}
            {mostrarModal && (
                <div className="fixed inset-0 z-50 overflow-y-auto animate-fade-in">
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => !savingUserData && setMostrarModal(false)}></div>
                    <div className="relative min-h-screen flex items-center justify-center p-4">
                        <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full animate-scale-in">
                            {/* Header con gradiente */}
                            <div className="gradient-red px-6 py-4 rounded-t-2xl shadow-lg">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                            <span className="material-icons text-white text-xl">edit</span>
                                        </div>
                                        <h2 className="text-white text-lg font-bold tracking-wide">EDITAR USUARIO</h2>
                                    </div>
                                    <button 
                                        onClick={() => !savingUserData && setMostrarModal(false)} 
                                        disabled={savingUserData}
                                        className="text-white/80 hover:text-white hover:rotate-90 transition-all duration-300 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed">
                                        <span className="material-icons text-xl">close</span>
                                    </button>
                                </div>
                            </div>
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                const formData = new FormData(e.target);
                                handleGuardarEdicion(formData);
                            }} className="p-6">
                                <div className="space-y-4">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-2">Nombre</label>
                                            <input 
                                                type="text" 
                                                name="nombre"
                                                defaultValue={usuarioEditando?.nombre}
                                                disabled={savingUserData}
                                                className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed" 
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-2">Apellido</label>
                                            <input 
                                                type="text" 
                                                name="apellido"
                                                defaultValue={usuarioEditando?.apellido}
                                                disabled={savingUserData}
                                                className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed" 
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-700 mb-2">Username</label>
                                        <input type="text" value={usuarioEditando?.username} readOnly className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 text-gray-600 font-mono focus:outline-none cursor-not-allowed" />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-700 mb-2">Email</label>
                                        <input 
                                            type="email" 
                                            name="email"
                                            defaultValue={usuarioEditando?.email}
                                            disabled={savingUserData}
                                            className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 disabled:bg-gray-100 disabled:cursor-not-allowed" 
                                        />
                                    </div>
                                    <div className="space-y-4">
                                        {/* Módulos */}
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-3">
                                                Módulos
                                            </label>
                                            <div className="flex items-center gap-6 flex-wrap">
                                                <label className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="cesiones"
                                                        defaultChecked={usuarioEditando?.modulos?.cesiones}
                                                        disabled={savingUserData}
                                                        className="w-4 h-4 text-honda-600 border-gray-300 rounded focus:ring-honda-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                                    />
                                                    <span className="text-sm text-gray-700">Cesiones</span>
                                                </label>
                                                <label className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="prendas"
                                                        defaultChecked={usuarioEditando?.modulos?.prendas}
                                                        disabled={savingUserData}
                                                        className="w-4 h-4 text-honda-600 border-gray-300 rounded focus:ring-honda-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                                    />
                                                    <span className="text-sm text-gray-700">Prendas</span>
                                                </label>
                                                <label className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="scoring"
                                                        defaultChecked={usuarioEditando?.modulos?.scoring}
                                                        disabled={savingUserData}
                                                        className="w-4 h-4 text-honda-600 border-gray-300 rounded focus:ring-honda-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                                    />
                                                    <span className="text-sm text-gray-700">Scoring</span>
                                                </label>
                                            </div>
                                        </div>
                                        {/* Estado - Solo ACTIVO/INACTIVO (BLOQUEADO se maneja en su propio modal) */}
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-700 mb-2">Estado</label>
                                            <select 
                                                name="estado"
                                                defaultValue={usuarioEditando?.bloqueado ? 'BLOQUEADO' : usuarioEditando?.estado}
                                                disabled={savingUserData || usuarioEditando?.bloqueado}
                                                className="w-full px-3 py-2.5 text-sm border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-honda-100 focus:border-honda-500 transition-all duration-300 cursor-pointer disabled:bg-gray-100 disabled:cursor-not-allowed">
                                                <option value="ACTIVO">ACTIVO</option>
                                                <option value="INACTIVO">INACTIVO</option>
                                                {usuarioEditando?.bloqueado && <option value="BLOQUEADO">BLOQUEADO</option>}
                                            </select>
                                            {usuarioEditando?.bloqueado && (
                                                <p className="text-xs text-amber-600 mt-2 flex items-center gap-1">
                                                    <span className="material-icons text-xs">info</span>
                                                    Para desbloquear, use el botón de bloqueo en la lista
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-100">
                                    <button 
                                        type="button" 
                                        onClick={() => setMostrarModal(false)}
                                        disabled={savingUserData}
                                        className="px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition-all duration-300 text-sm font-semibold hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
                                        Cancelar
                                    </button>
                                    <button 
                                        type="submit"
                                        disabled={savingUserData}
                                        className="px-5 py-2.5 gradient-red hover:shadow-glow-red text-white rounded-xl transition-all duration-300 text-sm font-semibold ripple-effect flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                                        {savingUserData ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                Guardando...
                                            </>
                                        ) : (
                                            'Guardar'
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal Reset - Mejorado */}
            {modalReset && (
                <div className="fixed inset-0 z-50 overflow-y-auto animate-fade-in">
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => setModalReset(false)}></div>
                    <div className="relative min-h-screen flex items-center justify-center p-4">
                        <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full animate-scale-in">
                            {/* Header con gradiente */}
                            <div className="gradient-red px-6 py-4 rounded-t-2xl shadow-lg">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                            <span className="material-icons text-white text-xl">autorenew</span>
                                        </div>
                                        <h2 className="text-white text-lg font-bold tracking-wide">RESETEAR USUARIO</h2>
                                    </div>
                                    <button onClick={() => setModalReset(false)} className="text-white/80 hover:text-white hover:rotate-90 transition-all duration-300 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/10">
                                        <span className="material-icons text-xl">close</span>
                                    </button>
                                </div>
                            </div>
                            <div className="p-6">
                                {/* Info del usuario */}
                                <div className="mb-5 p-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border-2 border-gray-200">
                                    <div className="flex items-center gap-2">
                                        <span className="material-icons text-honda-500">person</span>
                                        <p className="text-gray-700 text-sm">Usuario: <span className="font-bold text-honda-700">{usuarioEditando?.username}</span></p>
                                    </div>
                                </div>
                                {/* Link generado */}
                                {mostrarLink && resetLink && (
                                    <div className="mb-5 p-5 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border-2 border-green-200 shadow-inner animate-fade-in">
                                        <div className="flex items-center gap-2 mb-3">
                                            <span className="material-icons text-green-600">check_circle</span>
                                            <label className="text-sm font-bold text-green-800">Link de reseteo generado:</label>
                                        </div>
                                        <div className="flex gap-2 items-center mb-4">
                                            <input type="text" value={resetLink} readOnly className="flex-1 px-3 py-2.5 text-xs border-2 border-green-300 rounded-xl bg-white text-gray-700 focus:outline-none font-mono" />
                                            <button type="button" onClick={() => copyToClipboard(resetLink)} className="px-4 py-2.5 bg-green-600 hover:bg-green-700 hover:shadow-lg text-white rounded-xl transition-all duration-300 text-xs font-semibold flex items-center gap-2 ripple-effect">
                                                <span className="material-icons text-base">content_copy</span>
                                                Copiar
                                            </button>
                                        </div>
                                        <div className="flex gap-3 items-center justify-between pt-3 border-t border-green-300">                                       
                                            <p className="text-xs text-green-700 flex items-center gap-1">
                                                <span className="material-icons text-xs">info</span>
                                                Copie este link para enviarlo al usuario
                                            </p>
                                        </div>
                                    </div>
                                )}
                                <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
                                    <button onClick={() => setModalReset(false)} className="px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition-all duration-300 text-sm font-semibold hover:shadow-md">Cancelar</button>
                                    <button onClick={handleResetearUsuario} className="px-5 py-2.5 gradient-red hover:shadow-glow-red text-white rounded-xl transition-all duration-300 text-sm font-semibold ripple-effect flex items-center gap-2">
                                        <span className="material-icons text-lg">autorenew</span>
                                        Resetear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal Bloquear/Desbloquear - Mejorado */}
            {modalBloquear && (
                <div className="fixed inset-0 z-50 overflow-y-auto animate-fade-in">
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={() => !changingUserStatus && setModalBloquear(false)}></div>
                    <div className="relative min-h-screen flex items-center justify-center p-4">
                        <div className="relative bg-white rounded-2xl shadow-2xl max-w-sm w-full animate-scale-in">
                            {/* Header con gradiente rojo o verde */}
                            <div className={`px-6 py-4 rounded-t-2xl shadow-lg ${usuarioEditando?.bloqueado ? 'bg-gradient-to-r from-green-500 to-emerald-600' : 'gradient-red'
                                }`}>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                            <span className="material-icons text-white text-xl">
                                                {usuarioEditando?.bloqueado ? 'lock_open' : 'block'}
                                            </span>
                                        </div>
                                        <h2 className="text-white text-lg font-bold tracking-wide">
                                            {usuarioEditando?.bloqueado ? 'DESBLOQUEAR USUARIO' : 'BLOQUEAR USUARIO'}
                                        </h2>
                                    </div>
                                    <button 
                                        onClick={() => !changingUserStatus && setModalBloquear(false)}
                                        disabled={changingUserStatus}
                                        className="text-white/80 hover:text-white hover:rotate-90 transition-all duration-300 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed">
                                        <span className="material-icons text-xl">close</span>
                                    </button>
                                </div>
                            </div>
                            <div className="p-6">
                                {/* Alerta de advertencia */}
                                <div className={`flex items-start gap-3 mb-5 p-4 rounded-xl border-2 shadow-inner ${usuarioEditando?.bloqueado
                                        ? 'bg-gradient-to-br from-green-50 to-emerald-50 border-green-200'
                                        : 'bg-gradient-to-br from-red-50 to-orange-50 border-red-200'
                                    }`}>
                                    <span className={`material-icons text-2xl animate-pulse-subtle ${usuarioEditando?.bloqueado ? 'text-green-600' : 'text-red-600'
                                        }`}>
                                        {usuarioEditando?.bloqueado ? 'info' : 'warning'}
                                    </span>
                                    <p className={`text-sm font-semibold flex-1 ${usuarioEditando?.bloqueado ? 'text-green-800' : 'text-red-800'
                                        }`}>
                                        {usuarioEditando?.bloqueado
                                            ? '¿Está seguro que desea desbloquear este usuario? Recuperará su acceso al sistema.'
                                            : '¿Está seguro que desea bloquear este usuario? Esta acción impedirá su acceso al sistema.'}
                                    </p>
                                </div>
                                {/* Info del usuario */}
                                <div className="mb-5 p-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border-2 border-gray-200">
                                    <div className="flex items-center gap-2">
                                        <span className="material-icons text-honda-500">person</span>
                                        <p className="text-gray-700 text-sm">Usuario: <span className="font-bold text-honda-700">{usuarioEditando?.username}</span></p>
                                    </div>
                                </div>
                                <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
                                    <button 
                                        onClick={() => setModalBloquear(false)}
                                        disabled={changingUserStatus}
                                        className="px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition-all duration-300 text-sm font-semibold hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
                                        Cancelar
                                    </button>
                                    <button
                                        onClick={handleCambiarEstadoUsuario}
                                        disabled={changingUserStatus}
                                        className={`px-5 py-2.5 text-white rounded-xl transition-all duration-300 text-sm font-semibold ripple-effect flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${usuarioEditando?.bloqueado
                                                ? 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 hover:shadow-lg'
                                                : 'gradient-red hover:shadow-glow-red'
                                            }`}
                                    >
                                        {changingUserStatus ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                Procesando...
                                            </>
                                        ) : (
                                            <>
                                                <span className="material-icons text-lg">
                                                    {usuarioEditando?.bloqueado ? 'lock_open' : 'block'}
                                                </span>
                                                {usuarioEditando?.bloqueado ? 'Desbloquear' : 'Bloquear'}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal Nuevo Usuario - Link de Reseteo */}
            {modalNuevoUsuarioLink && nuevoUsuarioData && (
                <div className="fixed inset-0 z-50 overflow-y-auto animate-fade-in">
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"></div>
                    <div className="relative min-h-screen flex items-center justify-center p-4">
                        <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full animate-scale-in">
                            {/* Header con gradiente verde (éxito) */}
                            <div className="bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-4 rounded-t-2xl shadow-lg">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                            <span className="material-icons text-white text-xl">check_circle</span>
                                        </div>
                                        <h2 className="text-white text-lg font-bold tracking-wide">USUARIO CREADO EXITOSAMENTE</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="p-6">
                                {/* Información del usuario creado */}
                                <div className="mb-5 p-4 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border-2 border-green-200">
                                    <div className="space-y-2">
                                        <div className="flex items-center gap-2">
                                            <span className="material-icons text-green-600 text-lg">person</span>
                                            <p className="text-gray-700 text-sm">
                                                <span className="font-bold text-green-800">{nuevoUsuarioData.nombre} {nuevoUsuarioData.apellido}</span>
                                            </p>
                                        </div>
                                        <div className="flex items-center gap-2 ml-7">
                                            <p className="text-gray-600 text-xs">Username: <span className="font-mono font-semibold text-gray-800">{nuevoUsuarioData.username}</span></p>
                                        </div>
                                        {nuevoUsuarioData.email && (
                                            <div className="flex items-center gap-2 ml-7">
                                                <p className="text-gray-600 text-xs">Email: <span className="font-semibold text-gray-800">{nuevoUsuarioData.email}</span></p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Link de reseteo */}
                                <div className="mb-5 p-5 bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl border-2 border-amber-200 shadow-inner">
                                    <div className="flex items-center gap-2 mb-3">
                                        <span className="material-icons text-amber-600">vpn_key</span>
                                        <label className="text-sm font-bold text-amber-900">Link de Reseteo:</label>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                        <input 
                                            type="text" 
                                            value={resetLink} 
                                            readOnly 
                                            className="flex-1 px-3 py-2.5 text-xs border-2 border-amber-300 rounded-xl bg-white text-gray-700 focus:outline-none font-mono select-all" 
                                        />
                                        <button 
                                            type="button" 
                                            onClick={() => copyToClipboard(resetLink)} 
                                            className="px-4 py-2.5 bg-amber-600 hover:bg-amber-700 hover:shadow-lg text-white rounded-xl transition-all duration-300 text-xs font-semibold flex items-center gap-2 ripple-effect"
                                        >
                                            <span className="material-icons text-base">content_copy</span>
                                            Copiar
                                        </button>
                                    </div>
                                    <p className="text-xs text-amber-700 mt-3 flex items-center gap-1">
                                        <span className="material-icons text-xs">warning</span>
                                        Este link permite al usuario establecer su contraseña inicial
                                    </p>
                                </div>
                                <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
                                    <button 
                                        onClick={() => {
                                            setModalNuevoUsuarioLink(false);
                                            setNuevoUsuarioData(null);
                                            setResetLink('');
                                            setAlertaGlobal({
                                                tipo: 'success',
                                                mensaje: 'Usuario agregado correctamente'
                                            });
                                            setTimeout(() => {
                                                setAlertaGlobal(null);
                                            }, 3000);
                                        }} 
                                        className="px-6 py-2.5 gradient-red hover:shadow-glow-red text-white rounded-xl transition-all duration-300 text-sm font-semibold ripple-effect flex items-center gap-2"
                                    >
                                        <span className="material-icons text-lg">check</span>
                                        Entendido
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </MainLayout>
    );
};
export default ABMUsuarios;
